import axios from 'axios';
import { apiUrl, sessionName } from '../utils';

const doRequest = ({
  url,
  method = 'get',
  data = {},
  hasFile = false
}) => {
  return new Promise((resolve, reject) => {
    const jwt = localStorage.getItem(sessionName());
    let requestUrl = url;
    
    let api = null;
    if (hasFile) {
      api = axios.create({
        baseURL: apiUrl(),
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': jwt
        }
      })
    } else {
      api = axios.create({
        baseURL: apiUrl(),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': jwt
        }
      })
    }

    api[method](requestUrl, data)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export const doRequestGet = ({
  url
}) => {
  return doRequest({
    url,
  })
}

export const doRequestPost = ({
  url, data
}) => {
  return doRequest({
    url,
    data,
    method: 'post'
  })
}

export const doRequestFile = ({
  url, data = {}
}) => {
  return doRequest({
    url,
    data,
    method: 'post',
    hasFile: true
  })
}